import _extends from "@babel/runtime/helpers/esm/extends";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import { MenuItem } from '../Menu';
import { useDropdownContext } from './Dropdown.Context';
/**
 * @param {import('@wp-g2/create-styles').ViewOwnProps<import('./types').DropdownMenuItemProps, 'div'>} props
 * @param {import('react').Ref<any>} forwardedRef
 */

function DropdownMenuItem(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'DropdownMenuItem'),
      otherProps = _extends({}, _useContextSystem);

  var _useDropdownContext = useDropdownContext(),
      menu = _useDropdownContext.menu;

  return /*#__PURE__*/React.createElement(MenuItem, Object.assign({}, otherProps, menu, {
    ref: forwardedRef
  }));
}
/**
 * `DropdownMenuItem` is an actionable component that renders within a `Dropdown`.
 *
 * @example
 * ```jsx
 * <Dropdown>
 *  <DropdownTrigger>Edit</DropdownTrigger>
 *  <DropdownMenu>
 *    <DropdownMenuItem>...</DropdownMenuItem>
 *    <DropdownMenuItem>...</DropdownMenuItem>
 *    <DropdownMenuItem>...</DropdownMenuItem>
 *  </DropdownMenu>
 * </Dropdown>
 * ```
 *
 * @see https://reakit.io/docs/menu/#menuitem
 */


var ConnectedDropdownMenuItem = contextConnect(DropdownMenuItem, 'DropdownMenuItem');
export default ConnectedDropdownMenuItem;